function normalize(value: string): string {
  const path = value.split(/[?#]/)[0].trim().toLowerCase();
  if (!path) return '';

  const withSlash = path.startsWith('/') ? path : `/${path}`;

  return withSlash.length > 1 ? withSlash.replace(/\/+$/, '') : '/';
}

export function toPathList(value: unknown): string[] {
  if (!Array.isArray(value)) return [];

  return value
    .map(entry => {
      if (typeof entry === 'string') return normalize(entry);
      if (entry && typeof entry === 'object' && 'pathname' in entry) {
        const pathname = (entry as { pathname?: unknown }).pathname;
        return typeof pathname === 'string' ? normalize(pathname) : '';
      }
      return '';
    })
    .filter(Boolean);
}

export function matchesPath(pathname: string, paths: string[]): boolean {
  const current = normalize(pathname);

  return paths.some(
    path => path === current || (path !== '/' && current.startsWith(`${path}/`))
  );
}

export type BannerTargeting = {
  showEverywhere: boolean;
  includePaths: string[];
  excludePaths: string[];
};

export function isTargeted(banner: BannerTargeting, pathname: string): boolean {
  if (matchesPath(pathname, banner.excludePaths)) return false;
  if (banner.showEverywhere) return true;
  if (banner.includePaths.length)
    return matchesPath(pathname, banner.includePaths);

  return true;
}

export function pickBanner<T extends BannerTargeting & { id: number }>(
  banners: T[],
  pathname: string,
  dismissedIds: number[]
): T | undefined {
  return banners.find(
    banner => !dismissedIds.includes(banner.id) && isTargeted(banner, pathname)
  );
}
